import { WifiOff, Wifi, AlertCircle } from 'lucide-react';
import { useOfflineStatus } from '../../hooks/useOfflineStatus';

export function OfflineIndicator() {
  const { isOnline, wasOffline } = useOfflineStatus();

  if (isOnline && !wasOffline) return null;

  return (
    <div className={`
      fixed top-20 left-4 right-4 md:left-auto md:right-4 md:max-w-sm z-40
      transition-all duration-300 ease-in-out
    `}>
      <div className={`
        rounded-lg shadow-lg border p-3 flex items-center space-x-3
        ${isOnline 
          ? 'bg-green-50 dark:bg-green-900/20 border-green-200 dark:border-green-800' 
          : 'bg-amber-50 dark:bg-amber-900/20 border-amber-200 dark:border-amber-800'
        }
      `}>
        <div className="flex-shrink-0">
          {isOnline ? (
            <Wifi className="w-5 h-5 text-green-600 dark:text-green-400" />
          ) : (
            <WifiOff className="w-5 h-5 text-amber-600 dark:text-amber-400" />
          )}
        </div>
        
        <div className="flex-1 min-w-0">
          <p className={`text-sm font-medium ${
            isOnline 
              ? 'text-green-800 dark:text-green-300' 
              : 'text-amber-800 dark:text-amber-300'
          }`}>
            {isOnline ? 'Back online' : 'You\'re offline'}
          </p>
          <p className={`text-xs ${
            isOnline 
              ? 'text-green-600 dark:text-green-400' 
              : 'text-amber-600 dark:text-amber-400'
          }`}>
            {isOnline 
              ? 'Live rates will be updated' 
              : 'Using cached exchange rates'
            }
          </p>
        </div>

        {!isOnline && (
          <AlertCircle className="w-4 h-4 text-amber-600 dark:text-amber-400 flex-shrink-0" />
        )}
      </div>
    </div>
  );
}